// 仓储方认证页面参数管理
export class TabParam {
  constructor() {
    this.Page = { // 分页参数
      pageNo: 1,
      pageSize: 10,
      total: 0
    }
    this.listQuery = { // 查询参数
      companyType: undefined, // 认证类型
      auditStatus: undefined, // 审核状态
      companyName: undefined, // 公司名称
      startCreateDate: undefined, // 报审时间
      endCreateDate: undefined // 报审时间
    }
  }
  listQuery;
  Page;
}

export class FormParam {
  constructor() {
    this.dataForm = {
    }

    this.rules = {
    }
  }
  dataForm;
  rules;
}

export class tableClass {
  constructor() {
    this.table = null
    this.form = null
  }

  // 调用列表参数
  static getTable() {
    if (!this.table) {
      this.table = new TabParam()
    }
    return this.table
  }

  // 调用表单参数
  static getForm() {
    if (!this.form) {
      this.form = new FormParam()
    }
    return this.form
  }

  // 调用表单参数
  static getData() {
    // var form = this.getForm()
    return {

    }
  }
}
